import React from 'react';
import css from '../styles/area-startup.css';

const { Component } = React;

class AreaStartup extends Component {
  render() {
    return (
      <div className="areas-grid-item areas-grid-item--startup">
        <div class="areas-grid-item__wrapper">
          <div class="areas-area__hero">
          </div>
          <div class="areas-area__hero-text" data-aos="zoom-in">
            <h3>Business Formation</h3>
            <p>I can help you decide on the best type of new business entity for your situation – S Corporation, C Corporation, Limited Liability Company (LLC), Limited Partnership, General Partnership, Limited Liability Partnership, or Professional Corporation – properly document and form the new organization and help you plan for ongoing compliance and reporting requirements.</p>
          </div>
        </div>
      </div>
    );
  }
}

export { AreaStartup };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/area-startup.js